import { useTranslation } from 'react-i18next'

import { IFile } from '../files-model'

import FileRow from './FileRow'

import styles from './files-table.module.scss'

interface IFilesTableProps {
    files: IFile[]
    refetch: () => void
}

function FilesTable({ files, refetch }: IFilesTableProps) {
    const { t } = useTranslation()

    return (
        <table className={styles.filesTable}>
            <thead>
                <tr>
                    <th>{t('name')}</th>
                    <th>{t('last_modification')}</th>
                    <th>{t('status')}</th>
                    <th>{t('actions')}</th>
                </tr>
            </thead>

            <tbody>
                {files.map((file) => (
                    <FileRow key={file._id} file={file} refetch={refetch} />
                ))}
            </tbody>
        </table>
    )
}

export default FilesTable
